export const COLLABORATION_COMPANY = "COLLABORATION_COMPANY";
export const FETCHING_DATA = "FETCHING_DATA";
export const STRIPPED_LIST = "STRIPPED_LIST";
export const SET_COLLABORATIONS = "SET_COLLABORATIONS";
export const REQUEST_STATUS = "REQUEST_STATUS";
export const UPDATE_BUSINESS_INFO = "UPDATE_BUSINESS_INFO";
export const RESET_COLLABORATIONS = "RESET_COLLABORATIONS";